export const PARTNERSKAB = 'Partnerskab';
export const OUTBOUND = 'Outbound';
export const TCC = 'TCC';
export const FIRMABIL = 'Firmabil';
